// src/components/App/Requirements/SubModal.jsx

import React from 'react';
import { 
    Box, 
    Button, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    useTheme 
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber'; 

export default function SubscriptionModal({ open, onRetry, onPricing, onClose }) {
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                elevation: 24,
                sx: {
                    borderRadius: '16px', 
                    p: 0,
                    maxWidth: 400,
                    // Use the theme's paper color
                    bgcolor: 'background.paper',
                },
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, p: 3 }}>
                {/* Icon Wrapper */}
                <Box sx={{
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 40,
                    width: 40,
                    mt: 0.5,
                    borderRadius: '50%',
                    // Use the theme's warning color palette
                    bgcolor: theme.palette.warning.light,
                }}>
                    <WarningAmberIcon sx={{ color: theme.palette.warning.main }} />
                </Box>

                {/* Text Content */}
                <Box>
                    <DialogTitle sx={{ fontWeight: 500, p: 0, fontSize: '1.25rem', color: 'text.primary' }}>
                        Subscription Issue
                    </DialogTitle>
                    <DialogContent sx={{ p: 0, mt: 0.5 }}>
                        <DialogContentText sx={{ fontSize: '0.875rem', color: 'text.secondary' }}>
                            We couldn't verify your active subscription. This may be a temporary issue. Please try again, or visit our pricing page for other options.
                        </DialogContentText>
                    </DialogContent>
                </Box>
            </Box>
        
            <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
                <Button
                    onClick={onRetry}
                    variant="outlined"
                    sx={{
                        borderRadius: 9999,
                        textTransform: "none",
                        fontWeight: 500,
                        borderColor: 'divider', // Use theme's divider color
                        color: 'primary.main',
                        px: 3,
                    }}
                >
                    Try again
                </Button>
                <Button
                    onClick={onPricing}
                    variant="contained"
                    color="primary" // Use theme's primary color
                    sx={{
                        borderRadius: 9999,
                        textTransform: "none",
                        fontWeight: 500,
                        px: 3,
                    }}
                >
                    Go to pricing
                </Button>
            </DialogActions>
        </Dialog>
    );
}
